import { render, staticRenderFns } from "./PermissionListView.vue?vue&type=template&id=7b49f569&scoped=true&"
import script from "./PermissionListView.vue?vue&type=script&lang=js&"
export * from "./PermissionListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b49f569",
  null
  
)

export default component.exports